import { RightButton } from 'components/order/manifest/RightButton'
import { useDispatch, useSelector } from 'react-redux'
import { setConfirmationMessage, setModal } from 'reducers/listReducer'

export const RightButtonContainer = ({
    totalResult,
    orderCode,
    setOrderCode,
    isLoadingBulkManifest,
    isLoadingAddManualAWB,
    isLoadingBulkPrintManifest,
    setModalHandler,
    rightButtonConfirm,
    orderItem,
    onChangeAWB,
}) => {
    const dispatch = useDispatch()
    const { selectedValue, modal } = useSelector((state) => state.listReducer)

    const onClickRightButton = (message, modal = { confirm: true }) => {
        dispatch(setModal(modal))
        dispatch(setConfirmationMessage(message))
    }

    const onHideScanBarcode = () => {
        dispatch(setModal({ scan: false }))
        setOrderCode('')
    }

    const isSelectSameService = () => {
        const shippingName = selectedValue?.selectedIds[0]?.shipping_service
        return (
            selectedValue?.selectedIds?.length &&
            selectedValue?.selectedIds?.every((item) => item?.shipping_service === shippingName)
        )
    }

    const props = {
        selectedValue,
        onClickRightButton,
        totalResult,
        modal,
        onHideScanBarcode,
        orderCode,
        setOrderCode,
        isLoadingBulkManifest,
        isLoadingBulkPrintManifest,
        isLoadingAddManualAWB,
        isSelectSameService,
        rightButtonConfirm,
        setModalHandler,
        orderItem,
        onChangeAWB,
    }

    return <RightButton {...props} />
}
